var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "searchCon" },
        [
          _c(
            "el-form",
            { attrs: { "label-position": "top", size: "small" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("mdfeTranslate.CustomerCode"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t("basicData.PleaseSelect"),
                                filterable: "",
                                clearable: "",
                                remote: "",
                                "reserve-keyword": "",
                                "remote-method": _vm.getCustomerOption,
                              },
                              on: {
                                "visible-change": _vm.getCustomerOptionDialog,
                              },
                              model: {
                                value: _vm.queryForm.params.customerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerId",
                              },
                            },
                            _vm._l(_vm.customerOption, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.username + "（" + item.id + "）",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.creator") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                "remote-method": _vm.getUserList,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: { "visible-change": _vm.getUserListDialog },
                              model: {
                                value: _vm.queryForm.params.createUser,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "createUser",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "queryForm.params.createUser",
                              },
                            },
                            _vm._l(_vm.userList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label:
                                    item.realName + "(" + item.username + ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.stateZT") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "status", $$v)
                                },
                                expression: "queryForm.params.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.enable"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.disable"),
                                  value: 0,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("collectionCenter.Stored"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 10 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "numberSearch",
                          attrs: {
                            label: _vm.$t("collectionCenter.CreationTime"),
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "-",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "default-time": ["00:00:00", "23:59:59"],
                              "start-placeholder": _vm.$t(
                                "GlobalSetObj.startDate"
                              ),
                              "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                            },
                            model: {
                              value: _vm.queryForm.params.invoiceIssueTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "invoiceIssueTime",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.invoiceIssueTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-top": "10px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-search",
                        size: "mini",
                      },
                      on: { click: _vm.search },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh", size: "mini" },
                      on: { click: _vm.onReset },
                    },
                    [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permit",
                          rawName: "v-permit:remove",
                          value:
                            "btn:invoiceCenter:customerInvoiceSubjectConfiguration-add",
                          expression:
                            "'btn:invoiceCenter:customerInvoiceSubjectConfiguration-add'",
                          arg: "remove",
                        },
                      ],
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onViewEditDetail(null, 0)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("collectionCenter.add")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "header-cell-style": { background: "#f2f2f2", color: "black" },
                height: _vm.tableHeightRow.height,
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.serial"),
                  align: "center",
                  type: "index",
                  width: "80",
                  fixed: "left",
                },
              }),
              _vm._l(_vm.tableHeaderList, function (item) {
                return _c("el-table-column", {
                  key: item.prop,
                  attrs: {
                    align: item.align,
                    label: item.label,
                    "min-width": item.minWidth,
                    prop: item.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            item.prop === "status"
                              ? _c(
                                  "div",
                                  [
                                    scope.row.status === 1
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.enable"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : scope.row.status === 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.disable"
                                                )
                                              )
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "info",
                                              size: "mini",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "collectionCenter.Stored"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                )
                              : item.prop === "businessType"
                              ? _c("div", [
                                  scope.row.businessType === 0
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "collectionCenter.expressDelivery"
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  scope.row.businessType === 1
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("collectionCenter.lanshou")
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  scope.row.businessType === 2
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "basicData.StockingAndPickup"
                                            )
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : _c("div", [
                                  _vm._v(
                                    " " + _vm._s(scope.row[item.prop]) + " "
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.operation"),
                  align: "center",
                  fixed: "right",
                  width: "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          { attrs: { placement: "bottom", trigger: "hover" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  slot: "reference",
                                  size: "mini",
                                  type: "text",
                                },
                                slot: "reference",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-more",
                                  staticStyle: { "font-size": "26px" },
                                }),
                              ]
                            ),
                            _c("div", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:invoiceCenter:customerInvoiceSubjectConfiguration-view",
                                      expression:
                                        "'btn:invoiceCenter:customerInvoiceSubjectConfiguration-view'",
                                      arg: "remove",
                                    },
                                  ],
                                  staticStyle: { "margin-bottom": "10px" },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onViewEditDetail(
                                            scope.row,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("collectionCenter.View"))
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              scope.row.status === 0 || scope.row.status === 2
                                ? _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "permit",
                                          rawName: "v-permit:remove",
                                          value:
                                            "btn:invoiceCenter:customerInvoiceSubjectConfiguration-edit",
                                          expression:
                                            "'btn:invoiceCenter:customerInvoiceSubjectConfiguration-edit'",
                                          arg: "remove",
                                        },
                                      ],
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onViewEditDetail(
                                                scope.row,
                                                2
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("collectionCenter.edit")
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "permit",
                                      rawName: "v-permit:remove",
                                      value:
                                        "btn:invoiceCenter:customerInvoiceSubjectConfiguration-disableEnable",
                                      expression:
                                        "'btn:invoiceCenter:customerInvoiceSubjectConfiguration-disableEnable'",
                                      arg: "remove",
                                    },
                                  ],
                                },
                                [
                                  scope.row.status === 1
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "danger",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDisableEnable(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.Disable"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  scope.row.status === 0
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "success",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDisableEnable(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "collectionCenter.enable"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title:
              _vm.viewType === 1
                ? _vm.$t("collectionCenter.View")
                : _vm.$t("collectionCenter.edit"),
            visible: _vm.showDetailWindow,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            direction: "ltr",
            size: "100vw",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailWindow = $event
            },
            close: _vm.onCloseDetailWindow,
          },
        },
        [
          _c("view-detail", {
            key: _vm.detailKey,
            ref: "viewDetailRef",
            attrs: {
              "view-type": _vm.viewType,
              "form-element": _vm.formElement,
              "form-element-fixed": _vm.formElementFixed,
            },
            on: { closeDetail: _vm.closeDetail },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }